import {Routes} from '@angular/router';
import {languageGuard} from "../shared/guards/language.guard";
import {customerUserGuard} from "../shared/guards/customer-user.guard";
import {passwordChangeEnforcementGuard} from "../shared/guards/password-change-enforcement.guard";

export const chatRoutes: Routes = [
  {path: "", redirectTo: "detail/0/0", pathMatch: "full"},
  {
    path: "detail/:id/:star_id",
    loadComponent: () => import('../modules/chat/chat-display/chat-display.component').then((m) => m.ChatDisplayComponent),
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard],
    data: {preload: 'base'}
  },
];
